import { filterTime } from '@/api/filter';
export default {
  reportId: null,
  tabVal: null,
  orgId: null,
  userId: null,
  detailId: null,
  tableData: [],
  columns: [
    {
      title: '序号',
      type: 'index',
      align: 'center'
    },
    {
      title: '收益项',
      align: 'center',
      key: 'commissionName',
      minWidth: 160
    },
    {
      title: '规则说明',
      align: 'center',
      key: 'ruleName',
      minWidth: 280
    },
    {
      title: '税前收入（元）',
      align: 'center',
      key: 'amount',
      minWidth: 300
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }
  ],
  columns_1: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '出单人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '保单号',
      minWidth: 120,
      align: 'center',
      key: 'policyNo'
    },
    {
      title: '保险公司',
      minWidth: 90,
      align: 'center',
      key: 'companyName'
    },
    {
      title: '产品名称',
      minWidth: 120,
      align: 'center',
      key: 'productName'
    },
    {
      title: '险种名称',
      minWidth: 100,
      align: 'center',
      key: 'insuranceName'
    },
    {
      title: '保障期',
      minWidth: 100,
      key: 'guaranteeDesc',
      align: 'center'
    },
    {
      title: '缴费期',
      minWidth: 100,
      key: 'payDesc',
      align: 'center'
    },

    {
      title: '规模保费(元)',
      key: 'fee',
      minWidth: 120,
      align: 'center'
    },
    {
      title: '费率(%)',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: 'FYC（元）',
      minWidth: 90,
      align: 'center',
      key: 'commissionPrice'
    },
    {
      title: '承保时间',
      minWidth: 90,
      align: 'center',
      key: 'insureTime',
      render(h, params) {
        const value = filterTime(params.row.insureTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '生效时间',
      minWidth: 90,
      align: 'center',
      key: 'startTime',
      render(h, params) {
        const value = filterTime(params.row.startTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '保单状态',
      minWidth: 90,
      align: 'center',
      key: 'status',
      render(h, params) {
        const status = params.row.status;
        if (status == 1) {
          return <span>已承保</span>;
        } else if (status == -1) {
          return <span>已退保</span>;
        } else if (status == 0) {
          return <span>已终止</span>;
        }
      }
    }
  ],
  columns_2: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '出单人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '服务代理人',
      align: 'center',
      key: 'serviceAgentName',
      minWidth: 120
    },
    {
      title: '保单号',
      minWidth: 120,
      align: 'center',
      key: 'policyNo'
    },
    {
      title: '保险公司',
      minWidth: 90,
      align: 'center',
      key: 'companyName'
    },
    {
      title: '产品名称',
      minWidth: 120,
      align: 'center',
      key: 'productName'
    },
    {
      title: '险种名称',
      minWidth: 100,
      align: 'center',
      key: 'insuranceName'
    },
    {
      title: '保障期',
      minWidth: 100,
      key: 'guaranteeDesc',
      align: 'center'
    },
    {
      title: '缴费期',
      minWidth: 100,
      key: 'payDesc',
      align: 'center'
    },
    {
      title: '保单年度',
      align: 'center',
      key: 'curRenewalYears',
      minWidth: 100,
      render(h, params) {
        let curRenewalYears = params.row.curRenewalYears;
        return <span>{curRenewalYears ? curRenewalYears : '-'}</span>;
      }
    },
    {
      title: '交费期次',
      align: 'center',
      key: 'curRenewalTimes',
      minWidth: 100
    },
    {
      title: '规模保费(元)',
      key: 'fee',
      minWidth: 120,
      align: 'center'
    },
    {
      title: '费率(%)',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: 'RYC（元）',
      minWidth: 90,
      align: 'center',
      key: 'commissionPrice'
    },
    {
      title: '实收时间',
      minWidth: 90,
      align: 'center',
      key: 'serverEndDate',
      render(h, params) {
        const value = filterTime(params.row.serverEndDate, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '保单状态',
      minWidth: 90,
      align: 'center',
      key: 'status',
      render(h, params) {
        const status = params.row.status;
        if (status == 1) {
          return <span>已承保</span>;
        } else if (status == -1) {
          return <span>已退保</span>;
        } else if (status == 0) {
          return <span>已终止</span>;
        }
      }
    }
  ],
  columns_3: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '出单人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '保单号',
      minWidth: 120,
      align: 'center',
      key: 'policyNo'
    },
    {
      title: '保险公司',
      minWidth: 90,
      align: 'center',
      key: 'companyName'
    },
    {
      title: '产品名称',
      minWidth: 120,
      align: 'center',
      key: 'productName'
    },
    {
      title: '险种名称',
      minWidth: 100,
      align: 'center',
      key: 'insuranceName'
    },
    {
      title: '保障期',
      minWidth: 100,
      key: 'guaranteeDesc',
      align: 'center'
    },
    {
      title: '缴费期',
      minWidth: 100,
      key: 'payDesc',
      align: 'center'
    },
    {
      title: '保单年度',
      align: 'center',
      key: 'curRenewalYears',
      minWidth: 100,
      render(h, params) {
        let curRenewalYears = params.row.curRenewalYears;
        return <span>{curRenewalYears ? curRenewalYears : '-'}</span>;
      }
    },
    {
      title: '交费期次',
      align: 'center',
      key: 'curRenewalTimes',
      minWidth: 100
    },
    {
      title: '规模保费(元)',
      key: 'fee',
      minWidth: 120,
      align: 'center'
    },
    {
      title: '费率(%)',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '费用(元)',
      key: 'commissionPrice',
      align: 'center',
      width: '100'
    },
    {
      title: '承保时间',
      minWidth: 90,
      align: 'center',
      key: 'insureTime',
      render(h, params) {
        const value = filterTime(params.row.insureTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '生效时间',
      minWidth: 90,
      align: 'center',
      key: 'startTime',
      render(h, params) {
        const value = filterTime(params.row.startTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '保单状态',
      minWidth: 90,
      align: 'center',
      key: 'status',
      render(h, params) {
        const status = params.row.status;
        if (status == 1) {
          return <span>已承保</span>;
        } else if (status == -1) {
          return <span>已退保</span>;
        } else if (status == 0) {
          return <span>已终止</span>;
        }
      }
    }
  ],
  columns_4: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '工号',
      key: 'staffNo',
      align: 'center'
    },
    {
      title: '被推荐人姓名',
      key: 'userName',
      align: 'center'
    },

    {
      title: '增员类型',
      key: 'recommendType',
      align: 'center',
      render(h, params) {
        return <span>{params.row.type == '1' ? '直接增员' : '间接增员'}</span>;
      }
    },

    {
      title: '当期费用（元)',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '提点（%）',
      minWidth: 90,
      align: 'center',
      key: 'rate'
    },
    {
      title: '增员费用（元)',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '入职日期',
      key: 'entryTime',
      align: 'center',
      width: '150',
      render(h, params) {
        return <span>{filterTime(params.row.entryTime, 'YYYY-MM-DD')}</span>;
      }
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }
  ],
  columns_5: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '机构编码',
      key: 'orgCode',
      align: 'center'
    },
    {
      title: '推荐机构',
      key: 'organizationName',
      align: 'center'
    },
    {
      title: '当期费用（元）',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '提点（%）',
      minWidth: 90,
      align: 'center',
      key: 'rate'
    },
    {
      title: '推荐奖励（元）',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }
  ],
  columns_6: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '姓名',
      key: 'userName',
      align: 'center'
    },
    {
      title: '入职日期',
      key: 'entryDate',
      align: 'center',
      width: '150',
      render(h, params) {
        return <span>{filterTime(params.row.entryDate, 'YYYY-MM-DD')}</span>;
      }
    },
    {
      title: '当期费用（元）',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '提点（%）',
      minWidth: 90,
      align: 'center',
      key: 'rate'
    },
    {
      title: '育成津贴（元）',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }
  ],
  columns_7: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '管理职级',
      key: 'rankName',
      align: 'center'
    },
    {
      title: '当期费用（元）',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '提点（%）',
      minWidth: 90,
      align: 'center',
      key: 'rate'
    },
    {
      title: '管理津贴（元）',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }
  ],
  columns_8: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '出单人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '保单号',
      minWidth: 120,
      align: 'center',
      key: 'policyNo'
    },
    {
      title: '服务代理人',
      align: 'center',
      key: 'serviceAgentName',
      minWidth: 120
    },
    {
      title: '保险公司',
      minWidth: 90,
      align: 'center',
      key: 'companyName'
    },
    {
      title: '产品名称',
      minWidth: 120,
      align: 'center',
      key: 'productName'
    },
    {
      title: '险种名称',
      minWidth: 100,
      align: 'center',
      key: 'insuranceName'
    },
    {
      title: '保单状态',
      minWidth: 90,
      align: 'center',
      key: 'status',
      render(h, params) {
        const status = params.row.status;
        if (status == 1) {
          return <span>已承保</span>;
        } else if (status == -1) {
          return <span>已退保</span>;
        } else if (status == 0) {
          return <span>已终止</span>;
        }
      }
    },
    {
      title: '保障期',
      minWidth: 100,
      key: 'guaranteeDesc',
      align: 'center'
    },
    {
      title: '交费期',
      minWidth: 100,
      key: 'payDesc',
      align: 'center'
    },
    {
      title: '保单年度',
      align: 'center',
      key: 'curRenewalYears',
      minWidth: 100,
      render(h, params) {
        let curRenewalYears = params.row.curRenewalYears;
        return <span>{curRenewalYears ? curRenewalYears : '-'}</span>;
      }
    },
    {
      title: '交费期次',
      align: 'center',
      key: 'curRenewalTimes',
      minWidth: 100
    },
    {
      title: '应收时间',
      minWidth: 90,
      align: 'center',
      key: 'needPayDate',
      render(h, params) {
        const value = filterTime(params.row.needPayDate, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '实收时间',
      minWidth: 90,
      align: 'center',
      key: 'serverEndDate',
      render(h, params) {
        const value = filterTime(params.row.serverEndDate, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '实收保费(元)',
      key: 'payFee',
      minWidth: 120,
      align: 'center'
    },
    {
      title: '费率(%)',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '续年度服务费',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '个人当月R13（%）',
      minWidth: 110,
      align: 'center',
      key: 'r13'
    },
    {
      title: '调整系数',
      minWidth: 90,
      align: 'center',
      key: 'x'
    },
  ],
  columns_9: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '团队总人数',
      minWidth: 90,
      align: 'center',
      key: 'total'
    },
    {
      title: '团队经产品FYC',
      minWidth: 120,
      align: 'center',
      key: 'commission'
    },
    {
      title: '管理提点（%）',
      align: 'center',
      key: 'rate',
      minWidth: 120
    },
    {
      title: '团队当月R13（%）',
      minWidth: 90,
      align: 'center',
      key: 'r13'
    },
    {
      title: '奖励系数',
      minWidth: 120,
      align: 'center',
      key: 'y'
    },
    {
      title: '管理津贴（元）',
      minWidth: 100,
      align: 'center',
      key: 'award'
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }

  ],
  columns_10: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '被推荐人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '工号',
      minWidth: 120,
      align: 'center',
      key: 'staffNo'
    },
    {
      title: '职级',
      align: 'center',
      key: 'rankName',
      minWidth: 120
    },
    {
      title: '入职日期',
      key: 'entryTime',
      align: 'center',
      width: '150',
      render(h, params) {
        return <span>{filterTime(params.row.entryTime, 'YYYY-MM-DD')}</span>;
      }
    },
    {
      title: '所属机构',
      minWidth: 90,
      align: 'center',
      key: 'orgName'
    },
    {
      title: 'FYC（元）',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '推荐奖励（元）',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }
  ],
  columns_11: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '被直接育成人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '被直接育成人职级',
      align: 'center',
      key: 'rankName',
      minWidth: 120
    },
    {
      title: '被直接育成人团队人数',
      minWidth: 90,
      align: 'center',
      key: 'total'
    },
    {
      title: '团队经代产品FYC（元）',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '育成奖（元）',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: '130',
      fixed: 'right'
    }
  ],
  columns_12: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '出单人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '保单号',
      minWidth: 120,
      align: 'center',
      key: 'policyNo'
    },
    {
      title: '保险公司',
      minWidth: 90,
      align: 'center',
      key: 'companyName'
    },
    {
      title: '产品名称',
      minWidth: 120,
      align: 'center',
      key: 'productName'
    },
    {
      title: '险种名称',
      minWidth: 100,
      align: 'center',
      key: 'insuranceName'
    },
    {
      title: '保障期',
      minWidth: 100,
      key: 'guaranteeDesc',
      align: 'center'
    },
    {
      title: '交费期',
      minWidth: 100,
      key: 'payDesc',
      align: 'center'
    },

    {
      title: '保费(元)',
      key: 'fee',
      minWidth: 120,
      align: 'center'
    },
    {
      title: '费率(%)',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: '首年基础服务费（元）',
      minWidth: 90,
      align: 'center',
      key: 'commissionPrice'
    },
    {
      title: '承保时间',
      minWidth: 90,
      align: 'center',
      key: 'insureTime',
      render(h, params) {
        const value = filterTime(params.row.insureTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '生效时间',
      minWidth: 90,
      align: 'center',
      key: 'startTime',
      render(h, params) {
        const value = filterTime(params.row.startTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '保单状态',
      minWidth: 90,
      align: 'center',
      key: 'status',
      render(h, params) {
        const status = params.row.status;
        if (status == 1) {
          return <span>已承保</span>;
        } else if (status == -1) {
          return <span>已退保</span>;
        } else if (status == 0) {
          return <span>已终止</span>;
        }
      }
    }
  ],
  columns_13: [
    {
      title: '序号',
      align: 'center',
      width: 80,
      type: 'index'
    },
    {
      title: '出单人',
      minWidth: 90,
      align: 'center',
      key: 'userName'
    },
    {
      title: '保单号',
      minWidth: 120,
      align: 'center',
      key: 'policyNo'
    },
    {
      title: '保险公司',
      minWidth: 90,
      align: 'center',
      key: 'companyName'
    },
    {
      title: '产品名称',
      minWidth: 120,
      align: 'center',
      key: 'productName'
    },
    {
      title: '险种名称',
      minWidth: 100,
      align: 'center',
      key: 'insuranceName'
    },
    {
      title: '保障期',
      minWidth: 100,
      key: 'guaranteeDesc',
      align: 'center'
    },
    {
      title: '缴费期',
      minWidth: 100,
      key: 'payDesc',
      align: 'center'
    },

    {
      title: '规模保费(元)',
      key: 'fee',
      minWidth: 120,
      align: 'center'
    },
    {
      title: '费率(%)',
      minWidth: 90,
      align: 'center',
      key: 'commission'
    },
    {
      title: 'FYC（元）',
      minWidth: 90,
      align: 'center',
      key: 'commissionPrice'
    },
    {
      title: '提点（%）',
      minWidth: 90,
      align: 'center',
      key: 'rate'
    },
    {
      title: '管理津贴（元）',
      minWidth: 90,
      align: 'center',
      key: 'award'
    },
    {
      title: '承保时间',
      minWidth: 90,
      align: 'center',
      key: 'insureTime',
      render(h, params) {
        const value = filterTime(params.row.insureTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '生效时间',
      minWidth: 90,
      align: 'center',
      key: 'startTime',
      render(h, params) {
        const value = filterTime(params.row.startTime, 'YYYY-MM-DD');
        return <span>{value}</span>;
      }
    },
    {
      title: '保单状态',
      minWidth: 90,
      align: 'center',
      key: 'status',
      render(h, params) {
        const status = params.row.status;
        if (status == 1) {
          return <span>已承保</span>;
        } else if (status == -1) {
          return <span>已退保</span>;
        } else if (status == 0) {
          return <span>已终止</span>;
        }
      }
    }
  ],
};